import React, { useState } from 'react'
import { 
    Typography,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Paper,
 } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import { getVimeoReviewPageLink, getVimeoVideoDownloadLinks } from "../../apis/apiList/projectApi";
import { useMessage } from "../../context/MessageContext";

function DownloadVimeoVideo({ videoId, userDetails }) {
    const { showMessage } = useMessage();
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [downloadOptions, setDownloadOptions] = useState([]);

    const getVimeoReviewLink = async (videoId) => {
        try {
          const response = await getVimeoReviewPageLink(videoId, {
            headers: {
              "x-access-token": userDetails?.jwtToken
            },
          });
    
          const link = response?.data?.vimeoReviewPageLink;
          const newTab = window.open(link, '_blank');
          newTab.focus();
        } catch (error) {
          showMessage(error?.response?.data?.message, "error");
          return null;
        }
    }

    const downloadVimeoVideoUrl = async (videoId) => {
        setLoading(true);
        setOpen(true);
        try {
            const response = await getVimeoVideoDownloadLinks(videoId, {
                headers: {
                "x-access-token": userDetails?.jwtToken
                },
            });
            
            const files = response.videos.download;

			if (!files || files.length === 0) {
				return;
			}

			const sortedFiles = files.sort((a, b) => {
				const resA = (a.width || 0) * (a.height || 0);
				const resB = (b.width || 0) * (b.height || 0);
				return resB - resA;
			});

            setDownloadOptions(sortedFiles);
            setLoading(false);
        } catch (error) {
          showMessage(error?.response?.data?.message, "error");
          return null;
        }
    }
    const onClose= () => setOpen(false)

    const downloadFile = (url) => {
        const filename = url.split("/").pop().split("?")[0];
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }   
    
    return (
        <>
            <Box sx={{ p: '10px', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Typography variant='h6' mt='4px' onClick={() =>{getVimeoReviewLink(videoId)}} style={{ cursor: 'pointer', color: '#1976d2' }}>
                    Vimeo review page
                </Typography>
                <Typography variant='h6' mt='4px' 
                    onClick={() =>{downloadVimeoVideoUrl(videoId)}}
                    style={{ cursor: 'pointer', color: '#1976d2' }}
                >
                    Download
                </Typography>
            </Box>

            <Dialog
                open={open}
                onClose={onClose}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                    borderRadius: 3,
                    p: 1,
                    fontFamily: "Inter, sans-serif",
                    },
                }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 2,
                    }}
                >
                    <Typography sx={{ fontSize: 24, fontWeight: 700 }}>
                    Download
                    </Typography>

                    <IconButton onClick={onClose}>
                        <CloseIcon sx={{ fontSize: 26 }} />
                    </IconButton>
                </DialogTitle>

                {/* Body */}
                <DialogContent dividers sx={{ border: 0, px: 2 }}>
                    {loading && <Typography>Loading...</Typography>}

                    {!loading &&
                    downloadOptions?.map((file, index) => (
                        <Box
                        key={index}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            py: 1.6,
                            borderBottom: "1px solid #eee",
                        }}
                        >
                        {/* Left info */}
                        <Box>
                            <Typography
                            sx={{
                                fontSize: 18,
                                fontWeight: 600,
                                textTransform: "lowercase",
                            }}
                            >
                            {file.public_name || "source"}
                            </Typography>

                            <Typography
                            sx={{
                                fontSize: 14,
                                color: "#777",
                                mt: 0.3,
                            }}
                            >
                            {file.size_short} | {file.width} × {file.height}
                            </Typography>
                        </Box>

                        {/* Download Button */}
                        <Paper
                            elevation={0}
                            onClick={() => {downloadFile(file.link)}}
                            // onClick={() => window.open(file.link, "_blank")}
                            sx={{
                                p: 1.2,
                                borderRadius: 2,
                                cursor: "pointer",
                                backgroundColor: "#f0f0f0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                "&:hover": {
                                    backgroundColor: "#e4e4e4",
                                },
                            }}
                        >
                            <DownloadIcon />
                        </Paper>
                        </Box>
                    ))}
                </DialogContent>
                </Dialog>
        </>
    )
}

export default DownloadVimeoVideo